export const BASE_URL = process.env.REACT_APP_API_URL;

// TODO: remove this, check impact
export const Account_Type = [
  { value: "INT", label: "INT" },
  { value: "DOM", label: "DOM" }
];

// TODO: remove this, check impact
export const Product_Type = [
  { value: "B2B", label: "B2B" },
  { value: "B2C", label: "B2C" },
  { value: "Fulfillment", label: "Fulfillment" }
];

// TODO: remove this and move to theme/css file
const primaryColor = process.env.REACT_APP_PRIMARY_COLOR;
export const selectTheme = (theme) => {
  return {
    ...theme,
    borderRadius: "0.29rem",
    borderWidth: 1,
    colors: {
      ...theme.colors,
      // primary25: 'rgba(60,68,177,0.15)',
      // primary50: 'rgba(60,68,177,0.15)',
      primary: primaryColor
    }
  };
};

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 16;

export const BUTTON_CUSTOMS_CLEARED = "BUTTON_CUSTOMS_CLEARED";
export const BUTTON_HEALD_AT_CUSTOMS = "BUTTON_HEALD_AT_CUSTOMS";
export const BUTTON_REMARK_FOR_NON_DELIVERED =
  "BUTTON_REMARK_FOR_NON_DELIVERED";
export const REMARK_FOR_NON_DELIVERED = "REMARK_FOR_NON_DELIVERED";
export const BUTTON_CLEARANCE_COMPLETED = "BUTTON_CLEARANCE_COMPLETED";
export const BUTTON_CLEARANCE_HELD_AT = "BUTTON_CLEARANCE_HELD_AT";
